import request, { _POST } from "@/services/request";
import {
  DakeAuditTraceActivityReq,
  DakeSetTraceActivityDisplayReq,
  DakeTraceActivityDetailReq,
  DakeTraceActivityDetailRsp,
  DakeTraceActivityListReq,
  DakeTraceActivityListRsp,
  DakeTraceActivityOperationLogReq,
  DakeTraceActivityOperationLogRsp,
  DakeTraceActivityRegisterGroupReq,
  DakeTraceActivityRegisterGroupRsp,
  DakeTraceActivityRegisterListReq,
  DakeTraceActivityRegisterListRsp,
  DakeTraceTagListReq,
  DakeTraceTagListRsp,
  DakeUpdateTraceTagReq,
  DakeCreateTraceTagReq,
  DakeUpdateListTraceTagReq,
} from "@/data-contracts";

/**
 * 溯源活动列表
 * /admin/traceActivity/list
 *
 * @param params DakeTraceActivityListReq
 *
 * @returns DakeTraceActivityListRsp
 *
 * */
export const getTraceActivityList = (params?: DakeTraceActivityListReq) => {
  return request<DakeTraceActivityListRsp, DakeTraceActivityListReq>(
    _POST,
    "/admin/traceActivity/list"
  )(params || {});
};

/**
 * /admin/traceActivity/operationLog
 * 溯源活动操作记录
 *
 * @param params DakeTraceActivityOperationLogReq
 *
 * @returns DakeTraceActivityOperationLogRsp
 * */
export const getTraceActivityOperationLog = (params?: DakeTraceActivityOperationLogReq) => {
  return request<DakeTraceActivityOperationLogRsp, DakeTraceActivityOperationLogReq>(
    _POST,
    "/admin/traceActivity/operationLog"
  )(params || {});
};

/**
 * 设置溯源活动展示/隐藏
 *
 * /admin/traceActivity/display
 *
 * @param params DakeSetTraceActivityDisplayReq
 * @returns null
 * */
export const setTraceActivityDisplay = (params?: DakeSetTraceActivityDisplayReq) => {
  return request<null, DakeSetTraceActivityDisplayReq>(
    _POST,
    "/admin/traceActivity/display"
  )(params || {});
};

/**
 * 审核溯源活动
 * /admin/traceActivity/audit
 * @param params DakeAuditTraceActivityReq
 * @returns null
 * */
export const auditTraceActivity = (params?: DakeAuditTraceActivityReq) => {
  return request<null, DakeAuditTraceActivityReq>(
    _POST,
    "/admin/traceActivity/audit"
  )(params || {});
};

/**
 * 更新溯源标签
 * /admin/traceActivity/updateTag
 * */
export const updateTraceActivityTag = (params?: DakeUpdateListTraceTagReq) => {
  return request<null, DakeUpdateListTraceTagReq>(
    _POST,
    "/admin/traceActivity/updateTag"
  )(params || {});
};

/**
 *
 * 溯源活动详情
 *
 * /admin/traceActivity/detail
 *
 * @param params DakeTraceActivityDetailReq
 * @returns DakeTraceActivityDetailRsp
 *
 * */
export const getTraceActivityDetail = (params?: DakeTraceActivityDetailReq) => {
  return request<DakeTraceActivityDetailRsp, DakeTraceActivityDetailReq>(
    _POST,
    "/admin/traceActivity/detail"
  )(params || {});
};

/**
 * /admin/traceActivity/registerList
 * 溯源活动报名列表
 *
 * @param params DakeTraceActivityRegisterListReq
 *
 * @returns DakeTraceActivityRegisterListRsp
 *
 * */
export const getTraceActivityRegisterList = (params?: DakeTraceActivityRegisterListReq) => {
  return request<DakeTraceActivityRegisterListRsp, DakeTraceActivityRegisterListReq>(
    _POST,
    "/admin/traceActivity/registerList"
  )(params || {});
};

/**
 * 获取溯源活动报名对接群
 * /admin/traceActivity/registerGroup
 * @param params DakeTraceActivityRegisterGroupReq
 * @returns DakeTraceActivityRegisterGroupRsp
 * */
export const getTraceActivityRegisterGroup = (params?: DakeTraceActivityRegisterGroupReq) => {
  return request<DakeTraceActivityRegisterGroupRsp, DakeTraceActivityRegisterGroupReq>(
    _POST,
    "/admin/traceActivity/registerGroup"
  )(params || {});
};

/**
 *
 * 分页查询溯源标签
 * /admin/traceTag/list
 * DakeTraceTagListRsp
 * */
export const getTraceTagList = (params?: DakeTraceTagListReq) => {
  return request<DakeTraceTagListRsp, DakeTraceTagListReq>(
    _POST,
    "/admin/traceTag/list"
  )(params ?? {});
};

/**
 *
 * /admin/traceTag/update
 * 编辑溯源标签（上下架/排序）
 * @param params DakeUpdateTraceTagReq
 * */
export const updateTraceTag = (params?: DakeUpdateTraceTagReq) => {
  return request<null, DakeUpdateTraceTagReq>(_POST, "/admin/traceTag/update")(params || {});
};

/**
 * 新增溯源标签
 * /admin/traceTag/create
 * @param params DakeCreateTraceTagReq
 * */
export const createTraceTag = (params?: DakeCreateTraceTagReq) => {
  return request<null, DakeCreateTraceTagReq>(_POST, "/admin/traceTag/create")(params || {});
};

const sourceApis = {
  updateTraceActivityTag,
  createTraceTag,
  updateTraceTag,
  getTraceTagList,
  getTraceActivityList,
  getTraceActivityOperationLog,
  setTraceActivityDisplay,
  auditTraceActivity,
  getTraceActivityDetail,
  getTraceActivityRegisterList,
  getTraceActivityRegisterGroup,
};

export default sourceApis;
